import useVideos from "../../hooks/useVideos";
import VideoGrid from "./VideoGrid";
import VideoUploaderModal from "./VideoUploaderModal";

const VideoDashboard = () => {
    const {
        videos,
        loading,
        error,
        uploadVideos,
        deleteVideo,
        reorderVideos,
        fetchVideos
    } = useVideos("http://localhost:2500");

    return (
        <div>
            <h1>Video Dashboard</h1>
            {loading && <p>Loading videos...</p>}
            {error && <p style={{ color: "red" }}>Error fetching videos</p>}

            <VideoGrid
                videos={videos}
                allowReorder={true}
                reorderEndpoint="http://localhost:2500/api/videos/reorder"
                deleteEndpoint="http://localhost:2500/api/video/delete"
                refreshVideos={fetchVideos}
            />

            <VideoUploaderModal
                isOpen={true}
                onClose={() => { }}
                uploadEndpoint="http://localhost:2500/api/video"
                refreshVideos={fetchVideos}
            />
        </div>
    );
};



export default VideoDashboard;